import {
  Accordion,
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap";

const Faqs = () => {
  return (
    <>
      {/* banner area start + contact us section ( include all common classes ) */}
      <section className="main-banner-area contact-us-area faq-section">
        <Container>
          <div className="main-banner-inner">
            <Row className="align-items-center">
              <Col lg={6}>
                <div className="main-banner-content position-relative contact-us-card">
                  <h1>
                    <span>Frequently Asked Questions </span>
                  </h1>
                  <p>
                  Enjoy seamless convenience with Union Car and Boda , perfect for personal, corporate, and team travel needs.
                  </p>
                  <p className="toll-free-number">
                    <img
                      className="me-2"
                      alt="call-icon"
                      src={require("../assets/images/call-icon.svg").default}
                    />{" "}
                    Toll Free: 0800280025
                  </p>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-banner-img">
                  <img src={require("../assets/images/faqs-img.png")} />
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </section>
      {/* banner area end + contact us section ( include all common classes ) */}
      {/* faqs area start */}
      <section className="service-area">
        <Container>
          <div className="service-area-content bg-none">
            <div className="features-content">
              <h3>Frequently Asked Questions</h3>
              <p>
              Find answers to common questions and get the information you 
                <br />
                need in one place.
              </p>
            </div>
            <Tabs
              defaultActiveKey="union_app"
              id="uncontrolled-tab-example"
              className="mb-4"
            >
              <Tab eventKey="union_app" title="Union App">
                <div className="faqs-area">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        How does the Union App work?
                      </Accordion.Header>
                      <Accordion.Body>
                        <ol className="mx-3">
                          <li><b>Book a Ride:</b> Enter pick-up and drop-off locations to get an estimated fare.</li>
                          <li><b>Get a Driver:</b> The app finds the nearest available boda or car driver.</li>
                          <li><b>Track the Driver (Coming Soon):</b> Real-time tracking of the driver’s location and estimated arrival time.</li>
                          <li><b>Arrive Safely:</b> Riders can share trip details with loved ones for safety.</li>
                        </ol>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        How does Union App verify a driver’s identity?
                      </Accordion.Header>
                      <Accordion.Body>
                        The app compares the driver’s name and phone number with trusted data sources and identity documents. Verification takes up to 48 hours.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        What is the maximum amount I can deposit in my app?
                      </Accordion.Header>
                      <Accordion.Body>
                        UGX 1,000,000.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        Why can't I top up with another number?
                      </Accordion.Header>
                      <Accordion.Body>
                        For security reasons, only the registered number can be used for top-ups.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                        What if I don’t have enough balance for a ride?
                      </Accordion.Header>
                      <Accordion.Body>
                        Top up before taking the trip or pay the excess amount in cash.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        What do I do if my wallet top-up does not reflect?
                      </Accordion.Header>
                      <Accordion.Body>
                      Call toll-free 0800280025 or contact Union App support on WhatsApp (+256 200 980025) with a screenshot of the transaction ID and phone number.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                      How can I make money using the Union App?
                      </Accordion.Header>
                      <Accordion.Body>
                      There are multiple ways to earn. Download the Union App for riders and drivers for more details.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Tab>
              <Tab eventKey="ride_payment" title="Union Ride and Payment">
                <div className="faqs-area">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                      How are tariffs calculated?
                      </Accordion.Header>
                      <Accordion.Body>
                      Tariffs are based on distance, demand, and other factors.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                      Are there fixed fares for specific routes (e.g., Kampala to the airport)?
                      </Accordion.Header>
                      <Accordion.Body>
                      Details on fixed fares will be available in the app.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                      Can I schedule a trip request?
                      </Accordion.Header>
                      <Accordion.Body>
                      Yes, the scheduling feature will be available in the app.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                      How can I get a free trip?
                      </Accordion.Header>
                      <Accordion.Body>
                      Promotions and referral programs may offer free rides.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                      Is there a cancellation fee if a trip does not take place?
                      </Accordion.Header>
                      <Accordion.Body>
                      Cancellation fees may apply depending on the circumstances.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                      What if I forget my login details?
                      </Accordion.Header>
                      <Accordion.Body>
                      Use the password recovery option in the app or contact support.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                      What do I do if the driver delays ending the trip?
                      </Accordion.Header>
                      <Accordion.Body>
                      Contact customer support immediately.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7">
                      <Accordion.Header>
                      What if the rider refuses to cancel the ride and is not arriving on time?
                      </Accordion.Header>
                      <Accordion.Body>
                      Report the issue to customer support for resolution.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="8">
                      <Accordion.Header>
                      My trip showed a maximum fare, but the final charge was higher. What do I do?
                      </Accordion.Header>
                      <Accordion.Body>
                      Contact support with the trip details for fare adjustment.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Tab>
              <Tab eventKey="boda_dsd" title="Union Boda DSD">
                <div className="faqs-area">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                      Why do drivers have to pay to the Union?
                      </Accordion.Header>
                      <Accordion.Body>
                      It is a government requirement that all road users pay road fees. Additionally, part of the payment goes towards the rider's savings for future plans.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                      How much will the driver pay as part of their savings?
                      </Accordion.Header>
                      <Accordion.Body>
                      The driver shall pay UGX 1,000 per day or UGX 5,000 per week. A percentage goes to the local government, and the rest is allocated to savings.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                      Will the total amount a driver pays be in their savings account?
                      </Accordion.Header>
                      <Accordion.Body>
                      No, 40% of the money goes to the government, while 60% remains in their savings account.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                      How will the rider keep track of Union savings?
                      </Accordion.Header>
                      <Accordion.Body>
                      Riders can check with the SACCO. Since it is not a personal saving, they need to contact their representatives.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                      Suppose a rider dies, how will they benefit from the Union?
                      </Accordion.Header>
                      <Accordion.Body>
                      The Union provides compensation and insurance benefits. Specific details can be obtained from the SACCO.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                      How sure will the rider know that they are saving with the right scheme?
                      </Accordion.Header>
                      <Accordion.Body>
                      The Union ensures transparency and provides regular updates to riders.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                      Will the rider receive a notification after payment?
                      </Accordion.Header>
                      <Accordion.Body>
                      Yes, riders will receive a confirmation notification after every successful payment.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="7">
                      <Accordion.Header>
                      When does the rider start benefiting from the Union savings?
                      </Accordion.Header>
                      <Accordion.Body>
                      Riders will start benefiting from their savings after the first quarter from the initial saving time.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Tab>
              <Tab eventKey="rider_number_plate" title="Boda Rider and Number Plate Registration">
                <div className="faqs-area">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                      What is the registration process for the platform?
                      </Accordion.Header>
                      <Accordion.Body>
                      There are two options:
                      <ol className="mx-3">
                        <li>Dial <b>*274*66#</b> and follow the prompts.</li>
                        <li>Register physically through the stage chairman or designated areas.</li>
                      </ol>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                      Is there a fee attached to the registration process?
                      </Accordion.Header>
                      <Accordion.Body>
                      Yes. If you register using your phone, there is a fee of not more than UGX 100, depending on the speed of registration. Physical registration is free.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                      What are the requirements for registration?
                      </Accordion.Header>
                      <Accordion.Body>
                      Required details include:
                      <ol className="mx-3">
                        <li>Name</li>
                        <li>Stage</li>
                        <li>Permit</li>
                        <li>Number plate</li>
                        <li>Location (Stage, not residence)</li>
                        <li>National ID Number (NIN)</li>
                        <li>Phone number</li>
                      </ol>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Tab>
              <Tab eventKey="boda_dsd_fees" title="Boda DSD Fees Payment">
                <div className="faqs-area">
                  <Accordion>
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                      How do I pay using my phone?
                      </Accordion.Header>
                      <Accordion.Body>
                        Dial <b>*217*66#</b> and follow the prompts.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                      Is there a fee for making payments?
                      </Accordion.Header>
                      <Accordion.Body>
                      No, the payment process is free of charge.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                      Can I pay for another boda or account?
                      </Accordion.Header>
                      <Accordion.Body>
                      Yes. Dial <b>*217*66#</b> and select option 2 to pay for others.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                      What happens if I change or lose my boda?
                      </Accordion.Header>
                      <Accordion.Body>
                      Visit your stage chairman to update your information.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                      Can I register or pay if I don’t have a stage?
                      </Accordion.Header>
                      <Accordion.Body>
                      Yes, but having a stage is critical for identification.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                      Will I be able to see my savings balance?
                      </Accordion.Header>
                      <Accordion.Body>
                      Yes. Dial <b>*217*66#</b> and verify your number plate to check your balance.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="6">
                      <Accordion.Header>
                      What is the process of verifying my account?
                      </Accordion.Header>
                      <Accordion.Body>
                      After registration, dial <b>*217*66#</b> and select the verification option. Enter your number plate to complete verification.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </Tab>
            </Tabs>
          </div>
        </Container>
      </section>
      {/* faqs area end */}
    </>
  );
};
export default Faqs;
